import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LocationIcon16 = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M12.9336 9.33268C13.4006 8.49377 13.6667 7.52763 13.6667 6.49935C13.6667 3.27769 11.055 0.666016 7.83333 0.666016C4.61167 0.666016 2 3.27769 2 6.49935C2 7.52763 2.26606 8.49377 2.7331 9.33268C3.52583 10.7566 6.28644 13.5026 7.38112 14.5649C7.63479 14.8111 8.03188 14.8111 8.28555 14.5649C9.38022 13.5026 12.1408 10.7566 12.9336 9.33268ZM7.83333 8.33268C9.02995 8.33268 10 7.36263 10 6.16602C10 4.9694 9.02995 3.99935 7.83333 3.99935C6.63672 3.99935 5.66667 4.9694 5.66667 6.16602C5.66667 7.36263 6.63672 8.33268 7.83333 8.33268Z'
    fill={props.fill ?? '#B6B9BC'}
  />
</Svg>;

export default LocationIcon16;
